// Phase 6 — Track C T-C2. The singleton ApiClient instance for the web SPA.
//
// Web v1 runs cookie-mode only (per blueprint §7.4 / plan §2.5). Bearer
// mode is reserved for the mobile / CLI surfaces. The TokenStore is a
// NullTokenStore — cookies handle everything.
//
// `baseURL` is empty in production (the SPA is mounted at `/` by Express
// and the API lives at `/api`, same origin). In dev, Vite proxies
// `/api` → `http://localhost:3000` per `web/vite.config.ts`, so the empty
// base still works.

import { ApiClient, NullTokenStore } from '@dailydeck/shared/api';

export const apiClient: ApiClient = new ApiClient({
  baseURL: '',
  mode: 'cookie',
  tokenStore: new NullTokenStore(),
});
